export default __webpack_public_path__ + "static/media/logo.85f57ae4.gif";